/** 发布检查进度表 */
import React, { memo } from 'react';
import classNames from 'classnames';
import { Button, Text } from '@tencent/tea-component';
import PublishBtn from '@component/PublishBtn';
import './checkList.scss';
import useProgressOption from '@component/EventDetailNav/hooks/useProgressOption';
import useEventDetail from '@component/EventDetailNav/hooks/useEventDetail';
import { useStore } from '@utils/event-store/useEventData';
import PreviewBtn from '@component/PreviewBtn/index';
interface ListProps {
  data: any[];
  isSelectItem?: number;
  onSelect?: Function;
  className?: string;
  mode?: 1 | 2;
  isInGuideStatus?: boolean;
  clickBtn?: Function;
  callback?: Function;
  previewRef?: any;
  isHidePreview?: boolean;
}

const CheckPublishList = ({
  data,
  isSelectItem,
  onSelect,
  className,
  mode = 1,
  isInGuideStatus,
  clickBtn,
  callback,
  previewRef,
  isHidePreview = false,
}: ListProps) => {
  const { btnRedirect } = useProgressOption();
  const { errorInfo, eventInfo } = useStore();
  const { publishBtn, publishedNotEdited, gotoPreview } = useEventDetail(eventInfo, errorInfo);
  const isShowAnimationItem = [...data].reverse().findIndex((item) => item?.isEdit);

  return (
    <div className={classNames('check-list', className)}>
      {data.map((item: any, index) => (
        <div
          className={classNames('check-list-item', {
            'check-list-item_selected': !isInGuideStatus && isSelectItem === index,
            'check-list-item_complected': item?.isEdit,
            'is-show-animation': data?.length - 1 - isShowAnimationItem === index,
          })}
          onClick={() => onSelect?.(item, index)}
          key={index}
        >
          <div className="check-list-item_left">
            <div className="check-list-item_icon">
              <svg
                width="14"
                height="9"
                viewBox="0 0 14 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={classNames('icon-finish', {
                  'icon_is-show': item?.isEdit,
                  'icon_is-hide': !item?.isEdit,
                })}
              >
                <path
                  d="M1.5 3.5L5.1477 7.60367C5.33883 7.81869 5.67154 7.82846 5.87496 7.62504L12.5 1"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  className="icon-finish-line"
                />
              </svg>
              <span
                className={classNames('icon-number', {
                  'icon_is-show': !item?.isEdit,
                  'icon_is-hide': item?.isEdit,
                })}
              >
                {index + 1}
              </span>
            </div>
            <Text overflow> {item?.title}</Text>
          </div>
          <div className="check-list-item_right">
            {item?.type === 'publish' ? (
              <>
                {!isHidePreview && (
                  <PreviewBtn
                    previewRef={previewRef}
                    className={classNames('size-xs', {
                      'tea-btn_white': !publishedNotEdited && !isInGuideStatus,
                      'modal-tea-btn': mode === 2,
                    })}
                    isPreview={publishedNotEdited}
                    lookText={mode === 1 ? '查看活动' : '查看'}
                    gotoPreview={() => {
                      if (isInGuideStatus) {
                        clickBtn?.();
                        return;
                      }
                      gotoPreview();
                    }}
                  />
                )}
                {mode === 1 && !publishedNotEdited && (
                  <PublishBtn
                    type={publishBtn.btn as any}
                    disabled={publishBtn?.disabled || isInGuideStatus}
                    text={publishBtn.text}
                  />
                )}
              </>
            ) : (
              <Button
                className={classNames('size-xs', {
                  'tea-btn_white': item?.isEdit && !isInGuideStatus,
                })}
                type={item?.isEdit ? 'weak' : 'primary'}
                onClick={() => {
                  if (isInGuideStatus) {
                    clickBtn?.();
                    return;
                  }
                  btnRedirect?.(item?.type);
                  callback?.();
                }}
              >
                {item?.isEdit ? '编辑' : '添加'}
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(CheckPublishList);
